/**
 * Clinical Tab Component
 * Clinical assessments for RN Command Center
 */

import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ThermometerSun, Flag } from "lucide-react";
import { ClinicalAssessmentPanel } from "@/components/ClinicalAssessmentPanel";

const ClinicalTab = ({
  isDark,
  selectedPatient,
  setActiveTab
}) => {
  return (
    <Card className={isDark ? "bg-slate-800/50 border-slate-700" : "bg-white border-gray-200 shadow-lg"}>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-xl">
          <ThermometerSun className={isDark ? "text-orange-400" : "text-orange-600"} />
          Clinical Assessments
        </CardTitle>
        <CardDescription className="text-base">
          Large-font, high-contrast clinical views • Pain, Symptoms, Visit Frequency
        </CardDescription>
      </CardHeader>
      <CardContent>
        {selectedPatient ? (
          <ClinicalAssessmentPanel 
            patientId={selectedPatient.patient_id}
            patientName={selectedPatient.patient_name}
            isDark={isDark}
            onSave={(data) => {
              toast.success("Assessment saved for " + selectedPatient.patient_name);
              console.log("Assessment data:", data);
            }}
            mode="full"
          />
        ) : (
          <div className={`text-center py-16 ${isDark ? "text-slate-400" : "text-gray-500"}`} data-testid="clinical-no-patient">
            <ThermometerSun className={`w-16 h-16 mx-auto mb-4 ${isDark ? "text-slate-600" : "text-gray-300"}`} />
            <h3 className="text-xl font-semibold mb-2">No Patient Selected</h3>
            <p className="mb-6">Select a patient from the Hotlist to begin clinical assessment</p>
            <Button 
              onClick={() => setActiveTab("hotlist")}
              className="bg-teal-600 hover:bg-teal-700"
              data-testid="go-to-hotlist-btn"
            >
              <Flag className="w-4 h-4 mr-2" />
              Go to Hotlist
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ClinicalTab;
